'use server'

import { prisma } from '@/lib/db/prisma'
import { hashPassword } from '@/lib/auth/password'
import { UserRole } from '@/types'
import { signOut } from '@/lib/auth/auth.config'

export async function registerUser(data: {
  firstName: string
  lastName: string
  email: string
  password: string
}) {
  try {
    // Check if user already exists
    const existingUser = await prisma.user.findUnique({
      where: { email: data.email },
    })

    if (existingUser) {
      return { error: 'User with this email already exists' }
    }

    // Hash password
    const passwordHash = await hashPassword(data.password)

    // Create user with GUEST role
    const user = await prisma.user.create({
      data: {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        passwordHash,
        role: UserRole.GUEST,
      },
    })

    return { success: true, userId: user.id }
  } catch (error) {
    console.error('Registration error:', error)
    return { error: 'Failed to create account. Please try again.' }
  }
}

export async function logout() {
  await signOut({ redirect: true, redirectTo: '/login' })
}
